import React from 'react';
import { Typography, theme } from 'antd';

import { CustomTooltip } from '~components/Tooltip';
import { formatSearchPerformanceDomainCap, formatSearchPerformanceDomainCapHelp } from './SearchPerformanceAccess';

type Props = {
  used: number;
  max: number;
  planLabel: string;
  helpAtCap: string;
};

function SearchPerformanceDomainCapCounter({ used, max, planLabel, helpAtCap }: Props) {
  const { token } = theme.useToken();
  const atCap = used >= max;

  return (
    <CustomTooltip placement="top" message={atCap ? helpAtCap : formatSearchPerformanceDomainCapHelp(max)}>
      <Typography.Text
        type={atCap ? undefined : 'secondary'}
        style={{
          fontSize: token.fontSizeSM,
          cursor: 'help',
          color: atCap ? token.colorWarningText : undefined,
        }}
      >
        {formatSearchPerformanceDomainCap(used, max, planLabel)}
      </Typography.Text>
    </CustomTooltip>
  );
}

export default SearchPerformanceDomainCapCounter;
